export const OCR_DOCUMENT_TYPES = {
  CARTE_GRISE: "CARTE_GRISE",
  PERMIS_CONDUIRE: "PERMIS_CONDUIRE",
  RELEVE_INFORMATION: "RELEVE_INFORMATION",
};

export const OCR_DOCUMENT_NAMES = {
  CARTE_GRISE: "Carte grise",
  PERMIS_CONDUIRE: "Permis de conduire",
  RELEVE_INFORMATION: "Relevé d'informations",
};
